import { Icon } from "@iconify/react";
import { Alert, Button, Input, Modal, Textarea } from "../common";
import { useState } from "react";

const DirectMessageModal = ({ isOpen, onClose, businessName = "" }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const Header = () => (
    <div className="flex flex-row items-center gap-3">
      <img
        src="/icons/direct_message.svg"
        alt="direct message"
        className="w-12 h-12"
      />
      <div>
        <h3 className="text-xl font-semibold">Send Message</h3>
        <p className="text-sm text-[#253477B2]">{businessName}</p>
      </div>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} header={<Header />}>
      <form className="w-full flex flex-col gap-4" onSubmit={handleSubmit}>
        <Input
          name="name"
          variant="primary-blur"
          label="Your Name"
          labelIcon="mdi:user-outline"
          placeholder="Enter your name"
          className="p-3"
          value={formData.name}
          onChange={handleChange}
        />
        <Input
          name="email"
          variant="primary-blur"
          label="Your Email"
          labelIcon="mdi:email-outline"
          placeholder="Enter your email"
          className="p-3"
          value={formData.email}
          onChange={handleChange}
        />
        <Textarea
          name="message"
          variant="primary-blur"
          placeholder="Write your message here..."
          value={formData.message}
          onChange={handleChange}
        />
        <Alert
          variant="info"
          message="The business will receive your message and contact you via email within 24 hours."
        />

        <div className="w-full flex lg:flex-row flex-col items-center gap-3">
          <Button
            variant="secondary-blur"
            label="Cancel"
            className="font-semibold rounded-lg lg:w-1/2 w-full"
          />
          <Button
            variant="primary-gradient"
            label="Send Message"
            icon="mdi:message-outline"
            className="font-semibold rounded-lg lg:w-1/2 w-full"
            type="submit"
          />
        </div>
      </form>
    </Modal>
  );
};

export default DirectMessageModal;
